import React from "react";
import { useParams } from "react-router-dom";
import { fetchData, fetchCompanyInvestment, updateAsset } from "../api";
import { useNotifications } from "../helpers/useNotifications";
import { useQuery, useQueryClient } from "react-query";
import Spinner from "../components/Spinner/Spinner";
import Image from "../components/Image/Image";
import Grid from "../components/Grid/Grid";
import parse from "html-react-parser";
import formatNumber from "../helpers/formatNumber";

function AssetInfo() {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const createNotification = useNotifications();

  //* states
  const [showAssetEdit, setShowAssetEdit] = React.useState(false);
  const [assetValue, setAssetValue] = React.useState("");

  //* data fetching
  const { data, isLoading } = useQuery(["asset-info"], () =>
    fetchData("asset", id),
  );

  const { data: myInvestment } = useQuery(["myinvestment"], () =>
    fetchCompanyInvestment(id),
  );

  //* use Effect
  React.useEffect(() => {
    if (myInvestment) {
      setAssetValue(myInvestment?.investment);
    }
  }, [myInvestment]);

  if (isLoading) return <Spinner />;

  return (
    <>
      <div className="article-main">
        <Grid>
          <div
            style={{
              background: "linear-gradient(to right, #343A40, #525252)",
              width: "96vw",
            }}
          >
            <Grid>
              <a href={data?.homepage || ""} target="_blank">
                {data?.logo && (
                  <Image
                    width={100}
                    height={100}
                    source={data?.logo}
                    className="table-thumbnail stockinfo-icon"
                  />
                )}
              </a>

              <div
                style={{
                  marginTop: "10px",
                  marginLeft: "20px",
                  width: "50%",
                  overflow: "hidden",
                }}
              >
                <h4 className="text-light text-truncate">{data?.name}</h4>
                <span className="text-muted">{data.slogan || ""}</span>
              </div>
            </Grid>
          </div>
          {/* Personal data */}
          <Grid>
            <div
              className="col-4 text-center icon-click"
              onClick={() => setShowAssetEdit((prev) => !prev)}
            >
              <p className="stockinfo-keyfacts-label text-muted">
                Investment €
              </p>
              <p className="stockinfo-keyfacts-value text-light">
                {myInvestment?.investment
                  ? `${formatNumber((myInvestment?.investment).toFixed(2))}`
                  : "-"}
              </p>
            </div>
            <div className="col-4 text-center">
              <p className="stockinfo-keyfacts-label text-muted">
                Auszahlungen
              </p>
              <p className="stockinfo-keyfacts-value text-light">
                {myInvestment?.payouts && myInvestment?.payouts > 0
                  ? `${formatNumber(myInvestment?.payouts)}`
                  : "-"}
              </p>
            </div>
            <div className="col-4 text-center">
              <p className="stockinfo-keyfacts-label text-muted">
                Ausschüttung €
              </p>
              <p
                className="stockinfo-keyfacts-value"
                style={{
                  color: myInvestment?.dividends ? "lawngreen" : "white",
                }}
              >
                {myInvestment?.dividends
                  ? `${formatNumber((myInvestment?.dividends).toFixed(2))}`
                  : "-"}
              </p>
            </div>
          </Grid>
          {/* Description */}
          <div className="article-main">
            <h6 className="text-muted">Beschreibung</h6>
            <div id="meta-description" className={`text-light text-left`}>
              {data?.description && parse(data?.description)}
            </div>
          </div>
        </Grid>
      </div>

      <div
        className={`offcanvas offcanvas-bottom article-secondary-mobile ${
          showAssetEdit && "article-secondary-visible show"
        }`}
        tabIndex="-1"
        id="offcanvasBottom"
        aria-labelledby="offcanvasLabel"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="btn-close-custom dismiss-active-or-focus"
          >
            <i
              className="icon-click icon-close bi bi-x-lg text-muted"
              onClick={() => setShowAssetEdit((prev) => !prev)}
            />
          </button>
        </div>
        <div className="offcanvas-body article-secondary-scroll">
          <div className="article-secondary-info">
            {data?.logo && (
              <Image source={data?.logo} className="article-logo" />
            )}

            <h4 className="text-dark text-muted text-truncate">{data?.name}</h4>

            <div
              id="data-description"
              className="text-muted text-left article-base-description-active"
            >
              <form id="updateAsset">
                <div className="form-group col-12">
                  <label className="text-dark" for="value">
                    Investment
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      id="value"
                      name="value"
                      value={assetValue}
                      onChange={(e) => setAssetValue(e.target.value)}
                    />
                  </div>
                </div>
                <div style={{ marginLeft: "15px" }}>
                  <button
                    type="submit"
                    className="btn btn-primary btn-search-custom dismiss-active-or-focus"
                    onClick={(e) => {
                      e.preventDefault();

                      if (assetValue) {
                        updateAsset(id, assetValue)
                          .then((result) => {
                            createNotification("success", result.message);
                            queryClient.invalidateQueries(["myinvestment"]);
                            queryClient.invalidateQueries(["asset-info"]);
                            setShowAssetEdit(false);
                          })
                          .catch((err) => {
                            createNotification("error", err.message);
                          });
                      } else {
                        createNotification("error", "Bitte alle Daten angeben");
                      }
                    }}
                  >
                    Speichern
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AssetInfo;
